<template>
<div class="chapter">
<div class="inner_page">
<div class="section">
<div class="header">
<div class="hgroup">
<h3></h3>
<h1>Heart and Soul</h1>
</div>
</div>
<h3>
<span style="font-size: 1em; line-height: 1.5; text-indent: 1.5em;">Sally Mandel</span></h3>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 003_Title.vue?766c6e21